import { gql } from "@apollo/client";

export const GET_PRODUCTS = gql`
query QProductos($filter: InsumoFilterInput!) {
    productos(filter: $filter) {
        success,
        error,
        valorEsperado {
            idInsumoN,
            descripcion,
            descripcionGenerica,
            presentacionGenerica,
            presentacion,
            idFranjaEtarea,
            cantXPack,
            pesoUnitario,
            idInsumo,
            esSap,
            activo,
            validado,
            motivoValidacion,
            unidadVenta,
            fraccionable,
            proteinas,
            calorias
        }
    }
}`;

export const GET_PRODUCT = gql`
query QProducto ($id: Int!) {
    producto(id: $id)
        {
            success,
            error,
            valorEsperado {
                descUnidad,
                idFabricante,
                idTipoInsumo,
                activo,
                fechaAlta,
                descripcionGenerica,
                presentacionGenerica,
                descTipoInsumo,
                idFranjaEtarea,
                cantXPack,
                pesoUnitario,
                esSap,
                cantXDia,
                descFranjaEtarea,
                descLaboFabri,
                idInsumoN,
                idInsumo,
                descripcion,
                presentacion,
                idUnidad,
                eleccion,
                validado,
                motivoValidacion,
                unidadVenta,
                fraccionable,
                proteinas,
                calorias
            }
        }
}`;

export const GET_PRODUCTS_BY_FILTERS = gql`
query QProductosByFilters ($idTipoInsumo: Int!, $descripcion: String!) {
    productoByFilters(filtro: {
        descripcion: $descripcion,
        idTipoInsumo: $idTipoInsumo               
    })
        {
            success,
            error,
            valorEsperado {
                idInsumoN,
                idInsumo,
                descripcion             
            }
        }
}`;

export const GET_UNIDADES = gql`
query QUnidades {
   unidades
   {
       success,
       error,
       valorEsperado {
           idUnidad,
           descripcion,
           alias,
           activo
       }
   }
}`;

export const GET_FABRICANTES = gql`
query QFabricantes {
    laboratoriosFabricantes
    {
        success,
        error,
        valorEsperado {
            idLaboFabri,
            descripcion,
            activo
        }
    }
}`;

export const GET_TIPO_INSUMOS = gql`
query QTipoInsumos {
    tiposInsumos
    {
        success,
        error,
        valorEsperado {
            idTipoInsumo,
            codigo,
            descripcion,
            categoria
        }
    }
}`;

export const GET_FRANJA_ETARIA = gql`
query QFranjaEtaria {
    franjaEtaria
    {
        success,
        error,
        valorEsperado {
            id,
            descripcion,
            referencia,
            valor
        }
    }
}`;

export const GET_CATEGORIAS = gql`
query QCategorias {
    categorias
    {
        success,
        error,
        valorEsperado {
            idCategoria,
            descripcion
        }
    }
}`;

export const GET_SUB_CATEGORIAS = gql`
query QSubCategorias($idCategoria: Int!) {
    subCategorias(idCategoria: $idCategoria)
    {
        success,
        error,
        valorEsperado {
            idSubCategoria,
            descripcion
        }
    }
}`;

export const GET_PRESENTACION_NUTRICION = gql`
query QPresentacionNutricion {
    presentacionNutricion
    {
        success,
        error,
        valorEsperado {
            idPresentacionNutricion,
            descripcion
        }
    }
}`;

export const GET_EXISTS_COSTOINSUMO = gql`
query QExisteCostoInsumo ($mes: Int!, $anio: Int!) {
    existeCostoInsumo(mes: $mes, anio: $anio)
    {
        success,
        error,
        valorEsperado
    }
}`;

export const GET_TIPO_ACCESO = gql`
query QTipoAcceso {
    tipoAcceso
    {
        success,
        error,
        valorEsperado {
            idTipoAcceso,
            idSubTipoPrograma,
            nombre,
            activo
        }
    }
}`;

export const GET_ALERGIAS = gql`
query QAlergias {
    alergias
    {
        success,
        error,
        valorEsperado {
            idAlergia,
            descripcion
        }
    }
}`;

// by insumo
export const GET_COSTOS_BY_INSUMO = gql`
   query QCostos($idInsumo: Int!) {
       costoInsumo(idInsumo: $idInsumo)
       {
           success,
           error,
           valorEsperado {
               idCostoInsumo,
               idInsumo,
               idDelegacion,
               mes,
               anio,
               iva,
               costo1,
               costo2,
               costoInterno,
               cod_Proveedor,
               proveedor
           }
       }
   }`;

export const GET_ALERGIAS_BY_INSUMO = gql`
   query QAlergiasByInsumo($idInsumo: Int!) {
       productoAlergias(idInsumo: $idInsumo)
       {
           success,
           error,
           valorEsperado {
               idAlergia,
               descripcion
           }
       }
   }`;

export const GET_TIPOS_ACCESOS_BY_INSUMO = gql`
   query QTipoAccesoByInsumo($idInsumo: Int!) {
       productoTipoAcceso(idInsumo: $idInsumo)
       {
           success,
           error,
           valorEsperado {
                idTipoAcceso,
                idSubTipoPrograma,
                nombre,
                activo
           }
       }
   }`;

export const GET_COMPATIBILIDADES_BY_INSUMO = gql`
   query QCompatibilidadesByInsumo($idInsumo: Int!) {
       compatibilidad(idInsumo: $idInsumo)
       {
           success,
           error,
           valorEsperado {
               idCompatibilidad,
               idInsumo,
               descripcion
           }
       }
   }`;

export const GET_TM_BY_INSUMO = gql`
query QTMByInsumo($idInsumo: Int!) {
    tecnologiaMedica(idInsumo: $idInsumo)
    {
        success,
        error,
        valorEsperado {
            idInsumoTM,
            idInsumo,
            descripcion
        }
    }
}`;

export const GET_SUB_CATEGORIAS_BY_INSUMO = gql`
query QSubCategoriasByInsumo($idInsumo: Int!) {
    productoSubCategorias(idInsumo: $idInsumo)
    {
        success,
        error,
        valorEsperado {
            idSubCategoria,
            idInsumo,
            idPresentacion,
            eleccion,
            idCategoria
        }
    }
}`;

export const GET_INSUMO_CAJAS_BY_INSUMO = gql`
query QInsumoCajasByInsumo($idInsumo: Int!) {
    insumoCajas(idInsumo: $idInsumo)
    {
        success,
        error,
        valorEsperado {
            idInsumoCaja,
            idInsumo,
            cantidad,
            id,
            descripcion
        }
    }
}`;

export const GET_TIPO_MODULO_BY_INSUMO = gql`
query QGetInsumoTipoModulo($idInsumo: Int!) {
    insumoTipoModulo (idInsumo: $idInsumo)
    {
        success,
        error,
        valorEsperado {
            idInsumoModulo,
            idInsumo,
            idModuloTipo,
            idUsuario,
            fechaAlta
        }
    }
}`;

export const GET_PRODUCTOS_SAP = gql`
query QGetProductoSAP {
    productosSAP
        {
            success,
            error,
            valorEsperado {
                cod_articulo,
                descripcion,
                tipoArticulo,
                unidadMedida,
                grupoArticulo,
                sector
            }
        }
}`;

export const GET_COSTO_INSUMO_EXPORT = gql`
query QCostosInsumoExport {
    costoInsumoExport {
        success,
        error,
        valorEsperado {
            id,
            delegacion,
            proveedor,
            idInsumo,
            idDelegacion,
            mes,
            anio,
            iva,
            costo1,
            costo2,
            costoInterno,
            cod_Proveedor,
            activo,
            validado,
            descripcion
        }
    }
}`;

export const GET_PROGRAMAS = gql`
query QProgramas {
    programas {
        success,
        error,
        valorEsperado {
            idPrograma,
            idSubTipoPrograma,
            nombre,
            activo
        }
    }
}`;

export const GET_LUMENES = gql`
query GetAllLumenes {
    allLumenes {
        idLumenes,
        nombre,
        activo
    }
}`;

export const GET_ALL_ALERGIAS = gql`
query GetAllAlergias {
    allAlergias {
        idAlergia,
        descripcion,
        activo
    }
}`;

export const GET_ALL_TIPO_ACCESO = gql`
query GetAllTipoAcceso {
    allTipoAcceso{
        idTipoAcceso,
        nombre,
        activo
    }
}`;

export const GET_ALL_PRESENTACION_NUTRICION = gql`
query GetAllPresentacionNutricion {
    allPresentacionNutricion {
        idPresentacionNutricion,
        descripcion,
        activo
    }
}`;

export const GET_INSUMOS = gql`
query GetAllinsumos($skip : Int!, $take : Int!, $where : t_InsumoFilterInput) {
    allinsumos(skip: $skip, take: $take, where: $where) {
        items{
            idInsumoN,
            idInsumo,
            descripcion,
            descripcionGenerica
            activo,
            cantxPack,
            cantxDia,
            idAlergia{ idAlergia, descripcion },
            idFranjaEtareaNavigation { id, descripcion },
            idUnidadNavigation { idUnidad, descripcion },
            presentacion,
            idTipoAcceso { nombre, idTipoAcceso }
        },
        totalCount
    }
}`;

export const GET_INSUMOS_BY_TIPO_MODULO = gql`
query GetAllinsumosByIdTipoModulo($idTipoModulo: Int!, $skip : Int!, $take : Int!, $where : t_InsumoFilterInput) {
    allinsumosByIdTipoModulo(idTipoModulo: $idTipoModulo, skip: $skip, take: $take, where: $where) {
        items{
            idInsumoN,
            idInsumo,
            descripcion,
            descripcionGenerica
            activo,
            cantxPack,
            cantxDia,
            idAlergia{ idAlergia, descripcion },
            idFranjaEtareaNavigation { id, descripcion },
            idUnidadNavigation { idUnidad, descripcion },
            presentacion,
            idTipoAcceso { nombre, idTipoAcceso }
        },
        totalCount
    }
}`;

export const GET_INSUMOS_VALIDATE_RI = gql`
query GetAllInsumos($idEvaluacion: Int!, $where : t_InsumoFilterInput) {
    allInsumosValidateRI(idEvaluacion: $idEvaluacion, where: $where) {
        idInsumoN,
        idInsumo,
        descripcion,
        descripcionGenerica
        activo,
        cantxPack,
        cantxDia,
        idAlergia{ idAlergia, descripcion },
        idFranjaEtareaNavigation { id, descripcion },
        idUnidadNavigation { idUnidad, descripcion, alias },
        presentacion,
        idTipoAcceso { nombre, idTipoAcceso }
    }
}`;

export const adaptInsumo = (insumo) => {
  return {
    id: insumo?.idInsumoN,
    label: insumo?.descripcion,
    unidad: insumo?.idUnidadNavigation?.alias,
    idUnidad: insumo?.idUnidad
  };
};

export const adaptInsumosArray = (
insumos) =>
{
  return structuredClone(insumos?.allInsumosValidateRI)?.
  map((insumo) => adaptInsumo(insumo));
};